import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-doctor-list",
  templateUrl: "./doctor-list.component.html",
})
export class DoctorListComponent implements OnInit {
  rowsData = [
    {
      title: "First Name",
      underline: true,
      sorting: true,
      name: "physicianFirstName",
    },
    {
      title: "Last Name",
      underline: true,
      sorting: true,
      name: "physicianLastName",
    },
    { title: "Telephone" },
    { title: "Address", tooltip: true },
    { title: "City" },
    { title: "State" },
    { title: "Country" },
    { title: "Zip Code" },
  ];

  columnsData = [];
  columnsRes = [];
  p = 1;
  totalItems: any;
  currentPage = 1;
  page: number;
  maxSize = 10;
  maxSizeItem = 10;
  firstNameControl = new FormControl();
  formCtrlSub: Subscription;
  searchPatient = "";
  sortColumn = "physicianCreatedOn";
  orderColumn = "desc";
  searchText = "";
  alphaVal = "all";
  routerName = "";
  maxSizeItemValue: any;
  address: any = "";
  startDate = "";
  endDate = "";
  firstName: any = "";
  lastName: any = "";
  countryData = [];
  stateData = [];
  countryidadmin: any = "";
  stateidadmin: any = "";
  country: any = "";
  selectedCountry: any = "";
  selectedState: any = "";
  fromReport = true;
  constructor(
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private router: Router
  ) {}

  ngOnInit() {
    this.getAllCountry();

    this.supportService.physicianpage.subscribe((res) => {
      this.getAllDoctorsListAdmin("");
    });

    const url = this.router.url;

    if (
      url ===
      "/" + localStorage.getItem("testCode").toString().trim() + "/report-menu"
    ) {
      this.startDate = "";
      this.endDate = "";
    } else if (
      sessionStorage.getItem("startDate") &&
      sessionStorage.getItem("endDate")
    ) {
      this.startDate = sessionStorage.getItem("startDate");
      this.endDate = sessionStorage.getItem("endDate");
    } else {
      this.startDate = "";
      this.endDate = "";
    }
    this.supportService.gridSortingHeader.subscribe((res) => {
      if (res && res["length"] !== 0 && res["routerName"] === this.routerName) {
        this.sortColumn = res["name"];
        this.orderColumn = res["order"];
        const event = {
          page: 1,
        };
        this.currentPage = 1;
        this.getAllDoctorsListAdmin(event);
      }
    });
    this.checkUrl();
  }

  getAllCountry() {
    this.appService.getCountry().subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.countryData = res["entity"];
      } else {
        this.countryData = [];
      }
    });
  }

  getAllStateByCountry(countryid) {
    this.appService.getState(countryid).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.stateData = res["entity"];
      } else {
        this.stateData = [];
      }
    });
  }

  onChangeState(event) {
    sessionStorage.setItem("stateidadmin", this.selectedState.id);
    this.stateidadmin = sessionStorage.getItem("stateidadmin");
    this.getAllDoctorsListAdmin("");
  }

  onChange(event) {
    sessionStorage.setItem("countryidadmin", this.selectedCountry.id);
    this.countryidadmin = sessionStorage.getItem("countryidadmin");
    this.stateidadmin = "";
    this.getAllStateByCountry(event.id);
    this.selectedState = "";
    this.getAllDoctorsListAdmin("");
  }

  checkUrl() {
    const path = this.location.path().split("/");
    if (path.length === 3) {
      this.routerName = path[2];
    }
  }

  onBlurSearchMethod() {
    this.searchPatient = this.searchText;
    this.currentPage = 1;
    this.getAllDoctorsListAdmin("");
  }

  refreshPatient() {
    this.searchText = "";
    this.searchPatient = "";
    this.selectedCountry = "";
    this.selectedState = "";
    this.stateidadmin = "";
    this.countryidadmin = "";
    this.getAllDoctorsListAdmin("");
  }

  alphaSearch(val) {
    if (val !== "all") {
      this.searchPatient = val;
    } else {
      this.searchPatient = "";
    }
    this.alphaVal = val;
    this.searchText = "";
    this.getAllDoctorsListAdmin("");
  }

  getAllDoctorsListAdmin(event) {
    this.checkUrl();
    let data;
    if (event) {
      data = {
        pageNumber: event.page,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        startDate: this.startDate,
        endDate: this.endDate,
        countryid: this.countryidadmin,
        stateid: this.stateidadmin,
      };
    } else {
      data = {
        pageNumber: 1,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        startDate: this.startDate,
        endDate: this.endDate,
        countryid: this.countryidadmin,
        stateid: this.stateidadmin,
      };
    }

    this.appService.getAllDoctorsListAdminWithFilter(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsData = [];
            this.columnsRes = res["entity"];
            this.columnsRes.forEach((obj) => {
              this.address = "";
              if (obj.physicianAddressLine1) {
                this.address += obj.physicianAddressLine1 + ",";
              }
              if (obj.physicianAddressLine2) {
                this.address += obj.physicianAddressLine2;
              }
              if (obj.physicianFirstName) {
                if (
                  obj.physicianFirstName.indexOf("Dr") > -1 ||
                  obj.physicianFirstName.indexOf("dr") > -1
                ) {
                  this.firstName = obj.physicianFirstName;
                } else {
                  this.firstName = "Dr." + obj.physicianFirstName;
                }
              } else {
                this.firstName = "";
              }

              this.columnsData = this.columnsData.concat({
                param1: this.firstName ? this.firstName : "-",
                param2: obj.physicianLastName ? obj.physicianLastName : "-",
                param3:
                  obj.physicianPhone && obj.physicianPhoneCode === "+91"
                    ? obj.physicianPhoneCode +
                      " " +
                      obj.physicianPhone.replace(/^(\d{0,5})(\d{0,5})/, "$1-$2")
                    : obj.physicianPhone && obj.physicianPhoneCode === "+1"
                    ? obj.physicianPhoneCode +
                      " " +
                      obj.physicianPhone.replace(
                        /^(\d{0,3})(\d{0,3})(\d{0,4})/,
                        "($1) $2-$3"
                      )
                    : "-",
                param4: this.address ? this.address : "-",
                param5: obj.physicianCityName ? obj.physicianCityName : "-",
                param6: obj.physicianStateName ? obj.physicianStateName : "-",
                param7: obj.physicianCountryName
                  ? obj.physicianCountryName
                  : "-",
                param8: obj.physicianZipCode ? obj.physicianZipCode : "-",
                param10: obj.physicianId ? obj.physicianId : "-",
                param9: obj.testCenterId ? obj.testCenterId : "-",
                param13: "Double click for view",
              });
            });
            this.totalItems = res["count"];
          }
        } else {
          this.columnsData = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  pageChanged(event: any): void {
    this.page = event.page;
    this.getAllDoctorsListAdmin(event);
  }

  navigateToDashboard() {
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "dashboard",
    ]);
  }
}
